import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import useAuth from "../hooks/useAuthentication";
import { getUserData } from "../redux/slices/userSlices";

const ProtectedLogin = ({ props }: React.ReactElement) => {
  const isAuthed: boolean = useAuth();
  const user = useSelector(getUserData);
  return isAuthed ? <Navigate to={"/game"} replace /> : props;
};

export default ProtectedLogin;
